import React, { useState } from "react";
import { getPlacesByText } from "../../hooks/apis/Google/places.api";
import { SelectProps } from "antd";
import { DebounceSelect } from "../generic/DebounceSelect";

interface GooglePlaceInputProps {
    placeholder?: string;
    onPlaceSelected: (place: { place_id: string } | null) => void;
    loading: boolean;
}

export interface DebounceSelectProps<ValueType = any> extends Omit<SelectProps<ValueType | ValueType[]>, "options" | "children"> {
    fetchOptions: (search: string) => Promise<ValueType[]>;
    debounceTimeout?: number;
}

const GooglePlaceInput: React.FC<GooglePlaceInputProps> = ({ placeholder = "Search places...", onPlaceSelected, loading }) => {
    interface LocationValue {
        label: string;
        value: string;
    }

    const [value, setValue] = useState<LocationValue[]>([]);

    const handleGetPlacesByText = async (value: string) => {
        if (!value) return [];
        const places = await getPlacesByText(value);
        return places.predictions.map((place: any) => ({ label: place.description, value: place.place_id }));
    };

    return (
        <DebounceSelect
            onClear={() => {
                setValue([]);
                onPlaceSelected(null);
            }}
            loading={loading}
            value={value}
            showSearch
            allowClear
            placeholder={placeholder}
            fetchOptions={handleGetPlacesByText}
            onSelect={place => {
                onPlaceSelected({ place_id: place.value });
            }}
            onChange={newValue => {
                setValue(newValue as []);
            }}
            style={{ width: "100%" }}
        />
    );
};

export default GooglePlaceInput;
